<template>
	<transition-group name="list" tag="div" class="thumbs-view" @after-enter="onAfterEnter" :style="{ opacity: thumbs.length > 0 ? 1 : 0 }">
		<div v-for="(thumb, i) in thumbs" :key="thumb.thumb + i + (new Date()).getTime()" class="thumb" @click="$emit('click', $event, thumb.value)" :style="{ transitionDelay: `${(i * 100) + 500}ms` }">
			<div class="thumb" :style="{ backgroundImage: `url(${thumb.thumb})` }"></div>
			<div class="label">{{ thumb.label }}</div>
		</div>
	</transition-group>
</template>

<script>
	export default {
		props: {
			thumbs: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			onAfterEnter(el) {
				el.style.transitionDelay = '0ms';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.thumbs-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 230px;
		height: 100%;

		background: linear-gradient(90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%);

		pointer-events: none;

		transition: all 500ms ease-in-out; 

		box-sizing: border-box;
		
		padding-top: 130px;

		& > .thumb {
			margin: 20px 0 0 30px;
			display: grid;
			grid-template-rows: 112px auto;
			overflow: hidden;
			border-radius: 5px;
			cursor: pointer;
			transition: all 250ms ease-in-out;

			-webkit-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
			-moz-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
			box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);

			pointer-events: all;

			& > .thumb {
				background-size: cover;
			}

			& > .label {
				background-color: #1c1820c9;
				padding: 10px;
			}

			&:hover {
				transform: translate(20px, 0);
			}
		}

		.list-item {
			display: inline-block;
			margin-right: 10px;
		}

		.list-enter-active, .list-leave-active {
			transition: all 250ms ease-out;
		}

		.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
			opacity: 0;
			transform: translateX(-50px);
		}
	}

	@media only screen and (max-width: 1500px) {
		.thumbs-view {
			width: 150px;

			& > .thumb {
				grid-template-rows: 60px auto;

				& > .label {
					font-size: 12px;
					padding: 5px;
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.thumbs-view {
			width: 100%;

			& > .thumb {
				grid-template-rows: 0 auto;
				margin: 20px 5% 0 5%;

				& > .label {
					text-align: center;
					font-size: 20px;
					padding: 5px;
					line-height: 30px;
				}
			}
		}
	}
</style>